import { Skeleton, Stack, Typography } from '@mui/material';
import { GenSearch } from '@pinnacleautomotive/clarity-components';
import { useTranslation } from 'react-i18next';
import useVehicleOrdersForApproval from '../hooks/useVehicleOrdersForApproval';

export default function Filter() {
  const { totalResults, isLoading, setSearchQuery } =
    useVehicleOrdersForApproval();
  const { t } = useTranslation('orders');
  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      justifyContent="space-between"
      alignItems={{ xs: 'flex-start', md: 'center' }}
      gap={2}
    >
      <GenSearch
        placeholder={t('global:search')}
        sx={{
          width: { xs: '100%', md: '365px' },

          '& form': { margin: '0px !important', height: '100%' },
        }}
        searchTerm={setSearchQuery}
      />
      {(isLoading && <Skeleton variant="text" width={100} />) || (
        <Typography variant="overline">
          {totalResults} {t('vehicles')}
        </Typography>
      )}
    </Stack>
  );
}
